




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'ChybovyLogListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'ADM_ChybovyLog',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
